/**
 * Converts kopecks to rubles and formats them for display
 * @param kopecks - Amount in kopecks
 * @returns Formatted amount in rubles
 */
export const formatAmountFromKopecks = (kopecks: number): string => {
  if (kopecks === null || kopecks === undefined) return '0 ₽';
  
  return (kopecks / 100).toLocaleString('ru-RU', {
    style: 'currency',
    currency: 'RUB'
  });
};

/**
 * Converts kopecks to rubles as number
 * @param kopecks - Amount in kopecks
 * @returns Amount in rubles
 */
export const kopecksToRubles = (kopecks: number): number => {
  if (kopecks === null || kopecks === undefined) return 0;
  return kopecks / 100;
};

/**
 * Converts rubles to kopecks
 * @param rubles - Amount in rubles
 * @returns Amount in kopecks
 */
export const rublesToKopecks = (rubles: number): number => {
  if (rubles === null || rubles === undefined) return 0;
  return Math.round(rubles * 100);
};
